module.exports = __webpack_public_path__ + "img/gywmBanner.8793c321.png";